export default __webpack_public_path__ + "static/media/content.adc4db58.png";